import i18next from 'i18next';
import MainHeaderCell from 'components/common/datatable/MainHeaderCell';
import { cellWithTooltip } from 'components/common/datatable/EADataGrid';
import React from 'react';
import EAButton from 'components/common/EAButton';
import EAColorIcon from 'components/common/EAColorIcon';
import style from './style';

export const thirdPartyListColumns = (
  history,
  addTp,
  addedTpList,
  existingAssosciated,
  startPoint
) => {

  const { classes } = style();

  return [
    {
      field: 'name',
      headerName: i18next.t('tiers'),
      flex: 0.1,
      renderHeader: () => <MainHeaderCell name={i18next.t('thirdparty')} />,
      renderCell: (params) => cellWithTooltip(params.value),
    },
    {
      field: 'activityLabel',
      headerName: i18next.t('activity'),
      flex: 0.1,
      renderHeader: () => <MainHeaderCell name={i18next.t('activity')} />,
      renderCell: (params) => cellWithTooltip(params.value),
    },
    {
      field: 'followingDate',
      headerName: i18next.t('addedOn'),
      flex: 0.1,
      renderHeader: () => <MainHeaderCell name={i18next.t('addedOn')} />,
      renderCell: (params) => cellWithTooltip(params.value),
    },
    {
      field: 'action',
      headerName: i18next.t('actions'),
      flex: 0.1,
      sortable: false,
      filterable: false,
      disableExport: true,
      hideSortIcons: true,
      disableReorder: true,
      disableColumnMenu: true,
      disableMultipleSelection: true,
      disableSelectionOnClick: true,
      isRowSelectable: false,
      hideFooterSelectedRowCount: true,
      align: 'center',
      renderCell: (params) => {
        const isAdded = addedTpList.some(
          (tp) => tp.thirdPartyId === params.row.thirdpartyId
        );
        const doesExist = existingAssosciated.some(
          (tp) =>
            tp.compteFoId === params.row.thirdpartyId && tp.parentId === startPoint
        );
        const buttonText = isAdded
          ? i18next.t('context.addTiers.selectedTiers')
          : i18next.t('context.addTiers.associerButton');

        return (
          <>
            {doesExist ? (
              cellWithTooltip(i18next.t('context.addTiers.rank1Associated'))
            ) : (
              <EAButton
                onClick={() => addTp(params.row)}
                customStyle={{
                  height: '28px',
                  fontSize: '12px',
                  minHeight: '0px',
                  boxShadow: "none"
                }}
                colorVariant={ isAdded ?'primary':'primaryLight'}
                content={
                  <>
                    <EAColorIcon
                      icon={`/context/${
                        isAdded ? 'associated' : 'addAssocierPrimary'
                      }`}
                      svgStyle={{position: "relative", top: "1px"}}
                    />
                    <span className={isAdded ? classes.associateAdded : classes.associateToAdd}>
                      {buttonText}
                    </span>
                  </>
                }
                disabled={isAdded}
              />
            )}
          </>
        );
      },
    },
  ];
};
